/* RF Quick Buy — Gestion des tailles et CTA mobile */
        (function(){
          'use strict';
          const MOBILE_MAX = 699;
          const isMobile = () => matchMedia && matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;

          // ---------- RF: capture globale des clics sur les cards ----------
          document.addEventListener('click', (e) => {
            // Chercher la card dans plusieurs sélecteurs possibles
            const card = e.target.closest('product-card, .product-card, [data-product-handle], [data-handle], .card, .product-card__link');
            if (card) {
              window.__rfLastClickedCard = card;
              const handle = card.getAttribute('data-product-handle') || 
                           card.getAttribute('data-handle') || 
                           card.getAttribute('href')?.split('/products/')?.[1]?.split('?')?.[0];
              console.log('[RF] DEBUG - Card capturée:', handle);
            }
            
            // Si c'est un bouton quick-add, chercher la card parente
            if (e.target.closest('button[aria-label*="quick"], .quick-add, [data-quick-add]')) {
              const quickButton = e.target.closest('button[aria-label*="quick"], .quick-add, [data-quick-add]');
              const card = quickButton.closest('product-card, .product-card, [data-product-handle], [data-handle], .card');
              if (card) {
                window.__rfLastClickedCard = card;
                const handle = card.getAttribute('data-product-handle') || 
                             card.getAttribute('data-handle') || 
                             card.getAttribute('href')?.split('/products/')?.[1]?.split('?')?.[0];
                console.log('[RF] DEBUG - Card capturée via quick-add button:', handle);
              }
            }
          }, true);

          // ---------- RF: file d'attente 1-à-1 pour /cart/add.js ----------
          const rfAddQueue = [];
          let rfAddRunning = false;

          async function rfAddToCartQueued(payload) {
            return new Promise((resolve, reject) => {
              rfAddQueue.push({ payload, resolve, reject });
              runQueue();
            });
          }

          async function runQueue() {
            if (rfAddRunning) return;
            rfAddRunning = true;
            while (rfAddQueue.length) {
              const { payload, resolve, reject } = rfAddQueue.shift();
              try {
                const res = await fetch(`${Shopify.routes?.root || '/'}cart/add.js`, {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                  },
                  credentials: 'same-origin',
                  body: new URLSearchParams(payload)
                });
                if (!res.ok) throw new Error(`/cart/add.js ${res.status}: ${await res.text().catch(()=> '')}`);
                const item = await res.json().catch(()=> ({}));
                resolve(item);

                // respiration courte anti-throttle
                await new Promise(r => setTimeout(r, 400));
              } catch (e) {
                reject(e);
                // petite pause si erreur 429
                await new Promise(r => setTimeout(r, 800));
              }
            }
            rfAddRunning = false;
          }

          /* --- 1) Trouver & soumettre le vrai form natif, sans erreur --- */
          function findNativeForm(modal){
            // les cas Shopify fréquents
            return modal.querySelector(
              'product-form form, form.shopify-product-form, form[id*="product-form"], form[action*="/cart/add"]'
            );
          }
          function submitAddToCart(modal){
            const nativeBtn = modal.querySelector('button[type="submit"], [name="add"], .product-form__submit');
            const form = (nativeBtn?.form) || nativeBtn?.closest('form') || findNativeForm(modal);
            if (form && form.isConnected){
              // Utilise requestSubmit pour déclencher les handlers du thème
              form.requestSubmit(form.querySelector('button[type="submit"]') || nativeBtn || undefined);
              return true;
            }
            // fallback (au cas où) : click synthétique sur le bouton
            if (nativeBtn && nativeBtn.isConnected){
              nativeBtn.dispatchEvent(new MouseEvent('click', {bubbles:true, cancelable:true}));
              return true;
            }
            console.warn('[RF QB] No connected form/button found');
            return false;
          }

          /* --- 2) Nuke header + X même s'ils sont injectés après --- */
          function nukeTopChrome(modal){
            const kill = () => {
              // Masquer les éléments du header
              modal.querySelectorAll(
                '[slot="header"], .modal__header, .quick-buy-modal__header,' +
                ' dialog-close-button, [class*="close" i], [data-action="close"], [data-close],' +
                ' button[aria-label*="close" i], button[aria-label*="fermer" i]'
              ).forEach(el=>{
                el.setAttribute('aria-hidden','true');
                Object.assign(el.style, {display:'none', visibility:'hidden', opacity:'0', pointerEvents:'none', height:'0', margin:'0', padding:'0', overflow:'hidden'});
              });
              
              // Masquer le header du shadow DOM
              if (modal.shadowRoot) {
                const shadowHeader = modal.shadowRoot.querySelector('[part="header"]');
                if (shadowHeader) {
                  shadowHeader.style.display = 'none';
                  shadowHeader.style.visibility = 'hidden';
                  shadowHeader.style.opacity = '0';
                  shadowHeader.style.height = '0';
                  shadowHeader.style.overflow = 'hidden';
                }
              }
            };
            kill();
            new MutationObserver(kill).observe(modal, {childList:true, subtree:true});
          }



  function getOpenModals(){
    return [...document.querySelectorAll('.quick-buy-modal, dialog.quick-buy-modal')]
      .filter(m => m && (m.hasAttribute('open') || getComputedStyle(m).display !== 'none'));
  }

  // 1) helpers
  function qsa(root, sel){ return [...root.querySelectorAll(sel)]; }
  function setTextOnce(el, txt){ if (el && el.textContent.trim() !== (txt||'').trim()) el.textContent = (txt||'').trim(); }
  function setSrcOnce(img, src){ if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src); }
  function isOpen(m){ return m.hasAttribute('open') || getComputedStyle(m).display !== 'none'; }

  // Scan léger (radios, boutons, select) — court-circuit dès que trouvé
  async function waitForSizes(modal, timeout=1200){
    const start = performance.now();
    return await new Promise(resolve=>{
      (function tick(){
        // Sélecteurs plus larges pour capturer tous les types de tailles
        const radios = modal.querySelectorAll('input[type="radio"][name*="option"], input[type="radio"][name*="Size" i], input[type="radio"][name*="Taille" i], .product-form input[type="radio"]');
        const btns = modal.querySelectorAll('[data-option-name="Size"] button, .swatch[data-option-name="Size"] button, .variant-picker__option button, .variant-picker__option-values button, .block-swatch');
        const sels = modal.querySelectorAll('select[name*="Size" i], select[name*="Taille" i], select[name*="option"]');
        
        console.log('RF QB: waitForSizes scan:', {
          radios: radios.length,
          btns: btns.length,
          sels: sels.length,
          radioNames: [...radios].map(r => r.name),
          btnTexts: [...btns].map(b => b.textContent?.trim())
        });
        
        if (radios.length || btns.length || sels.length) {
          resolve({radios:[...radios], btns:[...btns], sels:[...sels]});
        } else if (performance.now() - start > timeout){
          resolve({radios:[], btns:[], sels:[]});
        } else {
          requestAnimationFrame(tick);
        }
      })();
    });
  }

  // Récupérer le libellé d'une taille
  function labelFor(inputOrBtn, root){
    if (!inputOrBtn) return '';
    if (inputOrBtn.tagName === 'BUTTON') return (inputOrBtn.innerText || '').trim();
    const id = inputOrBtn.id;
    const lbl = id ? root.querySelector(`label[for="${id}"]`) : null;
    return (lbl?.innerText || inputOrBtn.value || '').trim();
  }

  // Prix : sélection robuste (tous thèmes) + fallback
  function getPriceText(root){
    // 1) sélecteurs courants Shopify / thèmes
    const el = root.querySelector(`
      [data-product-price],
      [data-price],
      [itemprop="price"],
      .price__current, .price__regular, .price--large, .price, .product-price,
      .price-list, .price-list__item, .price__sale, .price__compare
    `);
    if (el && el.textContent) return el.textContent.trim();

    // 2) meta OG / schema.org
    const meta = root.querySelector('meta[itemprop="price"], meta[property="product:price:amount"]');
    if (meta?.content) return meta.content.trim();

    // 3) data-* numeric
    const holder = root.querySelector('[data-money],[data-price-value],[data-product-price-amount]');
    const v = holder?.getAttribute('data-money') || holder?.getAttribute('data-price-value') || holder?.getAttribute('data-product-price-amount');
    return v ? v.trim() : '';

    // 4) Fallback : chercher dans tout le document
    const allPrices = document.querySelectorAll('.price, [data-price], .price-list, .product-price');
    for (let priceEl of allPrices) {
      if (priceEl.textContent && priceEl.textContent.trim()) {
        return priceEl.textContent.trim();
      }
    }
    
    return '';
  }

  // Retourne une couleur CSS (rgb/hex) depuis le swatch actif si dispo
  function getActiveAccentFromModal(modal){
    // essaye d'attraper un swatch actif dans le modal…
    const swatch = modal.querySelector(
      '.swatch[aria-pressed="true"], .swatch.is-selected, .color-swatch[aria-pressed="true"], .card-color-swatch__link.active'
    );
    if (swatch){
      const cs = getComputedStyle(swatch);
      // on prend la couleur de fond, sinon la couleur du texte
      const bg = cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)' ? cs.backgroundColor : null;
      const fg = cs.color || null;
      return bg || fg || '#000';
    }
    return '#000';
  }

  // Applique l'accent au container .rf-qb
  function applyAccent(modal){
    const sheet = modal.querySelector('.rf-qb');
    if (!sheet) return;
    sheet.style.setProperty('--rf-accent', getActiveAccentFromModal(modal));
  }

  // Générer l'ID du modal size chart
  function generateSizeChartId(modal) {
    // Chercher l'ID du produit ou du formulaire
    const productForm = modal.querySelector('form[data-product-form]');
    const productId = productForm?.getAttribute('data-product-form') || 
                     modal.querySelector('[data-product-id]')?.getAttribute('data-product-id') ||
                     'default';
    
    return `size-chart-1-product-form-quick-buy-${productId}-template--24890322813264__main`;
  }

  // Trouver la carte produit correspondante au modal
  function findProductCardFromModal(modal) {
    // 1. Chercher par handle du produit
    const productHandle = modal.getAttribute('data-product-handle') || 
                         modal.querySelector('[data-product-handle]')?.getAttribute('data-product-handle');
    if (productHandle) {
      return document.querySelector(`[data-product-handle="${productHandle}"]`);
    }
    
    // 2. Chercher par titre du produit
    const productTitle = modal.querySelector('.rf-qb__title')?.textContent;
    if (productTitle) {
      const cards = document.querySelectorAll('.product-card, .card-product');
      for (let card of cards) {
        const cardTitle = card.querySelector('.product-card__title, .card-product__title, h3, h4')?.textContent;
        if (cardTitle && cardTitle.trim() === productTitle.trim()) {
          return card;
        }
      }
    }
    
    // 3. Chercher par URL du produit
    const productUrl = modal.querySelector('a[href*="/products/"]')?.href;
    if (productUrl) {
      const cards = document.querySelectorAll('.product-card, .card-product');
      for (let card of cards) {
        const cardUrl = card.querySelector('a[href*="/products/"]')?.href;
        if (cardUrl === productUrl) {
          return card;
        }
      }
    }
    
    return null;
  }

  // Image no-blink
  function swapImgNoBlink(imgEl, newSrc){
    if (!newSrc || imgEl.getAttribute('src') === newSrc) return;
    const tmp = new Image(); tmp.decoding='async';
    tmp.onload = () => { imgEl.src = newSrc; imgEl.style.opacity = '1'; };
    imgEl.style.opacity = '0'; tmp.src = newSrc;
  }

  // Convertir nom de couleur en valeur hex
  function getColorValue(colorName) {
    const colorMap = {
      'noir': '#000000',
      'black': '#000000',
      'blanc': '#ffffff',
      'white': '#ffffff',
      'bleu': '#0066cc',
      'blue': '#0066cc',
      'rouge': '#cc0000',
      'red': '#cc0000',
      'vert': '#00cc00',
      'green': '#00cc00',
      'jaune': '#ffff00',
      'yellow': '#ffff00',
      'orange': '#ff6600',
      'rose': '#ff99cc',
      'pink': '#ff99cc',
      'violet': '#6600cc',
      'purple': '#6600cc',
      'gris': '#666666',
      'gray': '#666666',
      'camel': '#d2b48c',
      'beige': '#f5f5dc',
      'marron': '#8b4513',
      'brown': '#8b4513'
    };
    
    const normalized = colorName.toLowerCase().trim();
    return colorMap[normalized] || '#cccccc'; // Gris par défaut
  }

  // Récupérer la variante sélectionnée
  function getSelectedVariant(modal) {
    console.log('Recherche de variante pour modal:', modal);
    
    // 1. Chercher dans le modal d'abord
    const variantInput = modal.querySelector('input[name="id"][value]');
    if (variantInput) {
      const variantId = variantInput.value;
      console.log('Variant ID trouvé:', variantId);
      // Chercher les données de variante dans le script ou data attributes
      const variantData = modal.querySelector(`[data-variant-id="${variantId}"]`) || 
                         modal.querySelector(`[data-variant="${variantId}"]`);
      if (variantData) {
        const option1 = variantData.getAttribute('data-option1') || variantData.getAttribute('data-color');
        console.log('Option1 trouvée:', option1);
        return {
          id: variantId,
          option1: option1,
          option2: variantData.getAttribute('data-option2') || variantData.getAttribute('data-size')
        };
      }
    }
    
    // 2. Chercher dans les swatches sélectionnés du modal
    const selectedSwatch = modal.querySelector('.swatch[aria-pressed="true"], .swatch.is-selected, .color-swatch[aria-pressed="true"], .variant-picker__option[aria-pressed="true"]');
    if (selectedSwatch) {
      const value = selectedSwatch.getAttribute('data-value') || selectedSwatch.textContent.trim();
      console.log('Swatch sélectionné dans modal:', value);
      return {
        option1: value,
        option2: null
      };
    }
    
    // 3. Chercher dans la carte produit spécifique (card-color-swatches)
    const productCard = findProductCardFromModal(modal);
    if (productCard) {
      console.log('Carte produit trouvée:', productCard);
      
      // Chercher TOUS les swatches et voir lequel est vraiment actif
      const allSwatches = productCard.querySelectorAll('.card-color-swatch__link');
      console.log('Tous les swatches trouvés:', allSwatches.length);
      
      for (let swatch of allSwatches) {
        // Vérifier si ce swatch est actif (plusieurs méthodes)
        const isActive = swatch.classList.contains('active') || 
                        swatch.classList.contains('is-selected') ||
                        swatch.classList.contains('selected') ||
                        swatch.getAttribute('aria-pressed') === 'true' ||
                        swatch.getAttribute('data-selected') === 'true' ||
                        swatch.style.backgroundColor !== '' ||
                        swatch.style.borderColor !== '';
        
        if (isActive) {
          const colorValue = swatch.getAttribute('data-color') || 
                           swatch.getAttribute('data-value') || 
                           swatch.textContent.trim();
          console.log('Swatch ACTIF trouvé:', colorValue, swatch);
          return {
            option1: colorValue,
            option2: null
          };
        }
      }
      
      // Si aucun actif trouvé, prendre le premier
      if (allSwatches.length > 0) {
        const firstSwatch = allSwatches[0];
        const colorValue = firstSwatch.getAttribute('data-color') || 
                         firstSwatch.getAttribute('data-value') || 
                         firstSwatch.textContent.trim();
        console.log('Premier swatch (fallback):', colorValue);
        return {
          option1: colorValue,
          option2: null
        };
      }
    }
    
    // 4. Chercher dans les data attributes du bouton quick add
    const quickAddBtn = document.querySelector('[data-quick-add], .quick-add-button, .product-form__submit');
    if (quickAddBtn) {
      const color = quickAddBtn.getAttribute('data-color') || quickAddBtn.getAttribute('data-option1');
      if (color) {
        console.log('Couleur trouvée dans bouton:', color);
        return {
          option1: color,
          option2: null
        };
      }
    }
    
    console.log('Aucune variante trouvée');
    return null;
  }

  // "Choisir les options" (header du thème) qui apparaît/disparaît
  function hideThemeHeader(modal){
    const heads = modal.querySelectorAll(
      '[slot="header"], .modal__header, .quick-buy-modal__header, [data-modal-header], .modal__title, .modal__heading'
    );
    heads.forEach(h=>{
      h.setAttribute('aria-hidden','true');
      h.style.display = 'none';
      h.style.visibility = 'hidden';
      h.style.height = '0px';
      h.style.margin = '0';
      h.style.padding = '0';
      h.style.overflow = 'hidden';
    });
  }

  // Fermer proprement selon le vrai statut d'ouverture
  function attachCloseWatch(modal, cleanup){
    // <dialog> standard
    if (typeof modal.addEventListener === 'function' && modal.nodeName === 'DIALOG'){
      modal.addEventListener('close', cleanup, {once:true});
    }
    // Fallback: on observe ce modal seulement
    const obs = new MutationObserver(()=>{
      const hidden = !modal.hasAttribute('open') && getComputedStyle(modal).display === 'none';
      if (hidden){ obs.disconnect(); cleanup(); }
    });
    obs.observe(modal, {attributes:true, attributeFilter:['open','style','class']});
  }

  function buildBottomSheet(modal, modalContent){
    let sheet = modal.querySelector('.rf-qb');
    if (sheet) return sheet;

    sheet = document.createElement('div');
    sheet.className = 'rf-qb quick-buy-mobile';
                const sizeChartId = generateSizeChartId(modal);
            sheet.innerHTML = `
              <div class="rf-qb__handle"></div>
              <div class="rf-qb__subhead">Sélection rapide</div>
              <div class="rf-qb__grid">
                <div class="rf-qb__media"><img class="rf-qb__img" alt=""></div>
                <div class="rf-qb__info">
                  <h3 class="rf-qb__title"></h3>
                  <div class="rf-qb__price"></div>
                  <div class="rf-qb__color"></div>
                </div>
                <!-- ↓↓↓ Désormais à ce niveau pour prendre toute la largeur ↓↓↓ -->
                <div class="rf-qb__sizes-row"></div>
              </div>
              <button class="rf-qb__cta" disabled>Choisir une taille</button>`;
    modalContent.appendChild(sheet);
    return sheet;
  }

            function enhanceModal(modal){
            if (modal.__rfEnhanced) return;
            

            
            // AU DÉBUT d'enhanceModal (juste après le guard __rfEnhanced) :
            nukeTopChrome(modal);
    
    console.log('Enhancing modal:', modal);
    
    // Cleanup complet avant de recommencer
    if (modal.__rfAbort) { 
      modal.__rfAbort.abort(); 
      modal.__rfAbort = null; 
    }
    
    // remove previous sheet so we start clean each time
    const prev = modal.querySelector('.rf-qb');
    if (prev) {
      console.log('Removing previous sheet');
      prev.remove();
    }

    const content = modal.querySelector('.quick-buy-modal__content, .modal__content');
    if (!content) {
      console.log('No content found in modal');
      return;
    }

    // ---------- RF: neutraliser le form du thème dans CE modal ----------
    const rfForm = content.querySelector('product-form form, form.shopify-product-form, form[id*="product-form"], form[action*="/cart/add"]');
    if (rfForm && !rfForm.__rfNeutralized) {
      // empêche toute soumission native dans CE modal
      rfForm.addEventListener('submit', (ev) => {
        ev.preventDefault();
        ev.stopImmediatePropagation();
      }, true);
      // bloque aussi les clicks "submit" du thème dans CE modal
      rfForm.addEventListener('click', (ev) => {
        const btn = ev.target.closest('button[type="submit"], [name="add"], .product-form__submit');
        if (btn) { ev.preventDefault(); ev.stopImmediatePropagation(); }
      }, true);
      rfForm.__rfNeutralized = true;
    }

    // create new abort controller for all listeners of this session
    const ac = new AbortController();
    modal.__rfAbort = ac;

    // build sheet (vide)
    const sheet = buildBottomSheet(modal, content);

                // === FAST RENDER depuis le contexte pending (swatch PLP) ===
                const pending = modal.__rfPending || null;
                console.log('RF QB: FAST RENDER - pending data:', pending);
                
                const titleEl = sheet.querySelector('.rf-qb__title');
                const priceEl = sheet.querySelector('.rf-qb__price');
                const imgEl = sheet.querySelector('.rf-qb__img');
                const row = sheet.querySelector('.rf-qb__sizes-row');
                const cta = sheet.querySelector('.rf-qb__cta');
                modal.classList.add('rf-qb-active');

                // ---------- RF: CTA = 1 seule requête, via la file ----------
                cta.addEventListener('click', async (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (cta.dataset.busy === '1') return;

                  cta.dataset.busy = '1';
                  cta.disabled = true;
                  cta.setAttribute('aria-busy', 'true');

                  try {
                    // Priorité 1: variant ID de la swatch cliquée
                    // Priorité 2: variant ID du formulaire natif
                    let variantId = window.__rfLastClickedSwatch?.getAttribute('data-variant-id');
                    let qtyEl = null;
                    
                    // Si on a une swatch cliquée ET une taille sélectionnée, essayer de trouver le bon variant
                    if (variantId) {
                      const selectedSizePill = modal.querySelector('.rf-qb__size[aria-pressed="true"]');
                      if (selectedSizePill) {
                        const selectedSize = selectedSizePill.textContent.trim();
                        console.log('[RF] DEBUG - Taille sélectionnée:', selectedSize);
                        
                        // Priorité 1: Chercher dans les variants du produit récupéré
                        if (window.__rfCurrentProductVariants) {
                          // Récupérer le variant ID de la swatch cliquée comme base
                          const swatchVariantId = window.__rfLastClickedSwatch?.getAttribute('data-variant-id');
                          console.log('[RF] DEBUG - Variant ID de la swatch cliquée:', swatchVariantId);
                          
                          // Chercher le variant de la swatch dans les données du produit
                          const swatchVariant = window.__rfCurrentProductVariants.find(v => v.id == swatchVariantId);
                          if (swatchVariant) {
                            console.log('[RF] DEBUG - Variant de la swatch trouvé:', swatchVariant.title);
                            
                            // APPROCHE SIMPLIFIÉE : Utiliser directement le variant ID de la taille sélectionnée
                            console.log('[RF] DEBUG - Recherche du variant pour la taille:', selectedSize);
                            
                            // Chercher le variant qui correspond exactement à la taille sélectionnée
                            const targetVariant = window.__rfCurrentProductVariants.find(variant => {
                              const variantTitle = variant.title || variant.option1 || '';
                              const sizeMatch = variantTitle === selectedSize || 
                                               variantTitle.includes(selectedSize) || 
                                               selectedSize.includes(variantTitle) ||
                                               variant.option1 === selectedSize;
                              
                              console.log('[RF] DEBUG - Test variant:', variantTitle, 'vs', selectedSize, '→', sizeMatch);
                              return sizeMatch;
                            });

                            
                            // Afficher tous les variants pour debug
                            console.log('[RF] DEBUG - Tous les variants disponibles:');
                            window.__rfCurrentProductVariants.forEach(v => {
                              console.log('[RF] DEBUG - Variant:', v.title, 'ID:', v.id, 'option1:', v.option1, 'option2:', v.option2);
                            });
                            
                            if (targetVariant) {
                              variantId = targetVariant.id;
                              console.log('[RF] DEBUG - Variant trouvé pour la taille:', targetVariant.title, ':', variantId);
                            } else {
                              console.log('[RF] DEBUG - Pas de variant trouvé pour la couleur et taille, affichage des variants disponibles:');
                              
                              // Afficher tous les variants disponibles pour debug
                              console.log('[RF] DEBUG - Aucun variant trouvé pour la taille:', selectedSize);
                              
                                                              window.__rfCurrentProductVariants.forEach(v => {
                                  console.log('[RF] DEBUG - Variant disponible:', v.title, 'ID:', v.id, 'option1:', v.option1, 'option2:', v.option2);
                                });
                              
                              console.log('[RF] DEBUG - Utilisation du variant de la swatch');
                              
                              // Fallback: essayer de récupérer le variant ID depuis les éléments natifs
                              const nativeElements = modal.querySelectorAll('input[type="radio"], button[data-value], .variant-picker__option button');
                              for (const element of nativeElements) {
                                const elementLabel = element.getAttribute('data-value') || 
                                                   element.value || 
                                                   element.textContent?.trim() ||
                                                   element.innerText?.trim();
                                
                                if (elementLabel === selectedSize) {
                                  const nativeVariantId = element.value || element.getAttribute('data-variant-id') || element.id;
                                  if (nativeVariantId && nativeVariantId !== swatchVariantId) {
                                    console.log('[RF] DEBUG - Utilisation du variant ID des éléments natifs:', nativeVariantId);
                                    variantId = nativeVariantId;
                                    break;
                                  }
                                }
                              }
                              
                              if (variantId === swatchVariantId) {
                                console.log('[RF] DEBUG - Utilisation du variant de la swatch comme fallback');
                              }
                            }
                          } else {
                            console.log('[RF] DEBUG - Variant de la swatch non trouvé dans les données du produit');
                          }
                        }
                      }
                      
                      qtyEl = modal.querySelector('input[name="quantity"]');
                    } else {
                      // Fallback: utiliser le formulaire natif
                      const form = modal.querySelector('product-form form, form.shopify-product-form, form[id*="product-form"], form[action*="/cart/add"]');
                      const idEl  = form?.querySelector('input[name="id"]');
                      qtyEl = form?.querySelector('input[name="quantity"]');

                      // si l'id met 1–2 frames à arriver après un clic taille, on attend un peu
                      if (!idEl?.value) {
                        const t0 = performance.now();
                        while (!idEl?.value && performance.now() - t0 < 500) {
                          await new Promise(r => requestAnimationFrame(r));
                        }
                      }
                      variantId = idEl?.value;
                    }
                    console.log('[RF] DEBUG - Variant ID final:', variantId);
                    console.log('[RF] DEBUG - Swatch cliquée:', window.__rfLastClickedSwatch?.getAttribute('data-variant-id'));
                    if (!variantId) { console.warn('[RF] Pas de variant id'); return; }

                    const quantity = Math.max(1, Number(qtyEl?.value || 1));

                    console.log('[RF] Adding to cart:', variantId, 'qty:', quantity);

                    // → UNE SEULE requête, sérialisée
                    const item = await rfAddToCartQueued({ id: variantId, quantity: String(quantity) });

                    // avertir le thème (drawer, badge, etc.)
                    document.dispatchEvent(new CustomEvent('variant:add', { detail: { variantId, item } }));
                    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item } }));
                    // modal.close?.(); // si tu veux le fermer ici
                  } catch (err) {
                    console.error('[RF] add failed', err);
                    // TODO: afficher un toast
                  } finally {
                    cta.removeAttribute('aria-busy');
                    cta.disabled = false;
                    delete cta.dataset.busy;
                  }
                }, { signal: ac.signal });
                
                // 1) titre + image immédiats
                        if (pending?.title) titleEl.textContent = pending.title;
                        
                        // Mettre à jour le variant ID depuis la swatch cliquée
                        if (pending?.variantId) {
                          const form = modal.querySelector('product-form form, form.shopify-product-form, form[id*="product-form"], form[action*="/cart/add"]');
                          if (form) {
                            let idInput = form.querySelector('input[name="id"]');
                            if (!idInput) {
                              idInput = document.createElement('input');
                              idInput.type = 'hidden';
                              idInput.name = 'id';
                              form.appendChild(idInput);
                            }
                            idInput.value = pending.variantId;
                            console.log('[RF] Variant ID initial mis à jour depuis la swatch:', pending.variantId);
                          }
                        }
                
                // Prix depuis le modal natif (fallback si pas dans pending)
                const newPrice = getPriceText(content) || getPriceText(document) || '';
                if (newPrice) {
                  let cleanPrice = newPrice.replace(/Prix de vente/i, '').replace(/Prix/i, '').replace(/vente/i, '').trim();
                  
                  // Formater le prix avec les classes CSS pour le prix barré
                  if (cleanPrice.includes('normal')) {
                    // Extraire le prix actuel et l'ancien prix
                    const parts = cleanPrice.split('normal');
                    const currentPrice = parts[0].trim();
                    const oldPrice = parts[1].trim();
                    
                    priceEl.innerHTML = `<span class="rf-qb__price-current">${currentPrice}</span> <span class="rf-qb__price-old">${oldPrice}</span>`;
                    console.log('RF QB: Prix formaté avec barré:', currentPrice, oldPrice);
                  } else {
                    priceEl.textContent = cleanPrice;
                    console.log('RF QB: Prix simple:', cleanPrice);
                  }
                } else {
                  console.log('RF QB: Aucun prix trouvé');
                  priceEl.textContent = 'Prix non disponible';
                }
                
                const imgInModal = modal.querySelector('.quick-buy-modal__gallery-wrapper img, .product-gallery img');
                swapImgNoBlink(imgEl, pending?.mainImg || imgInModal?.src || imgEl.src);
                
                // 2) couleur immédiate (seulement si des données sont disponibles)
                const colorEl = sheet.querySelector('.rf-qb__color');
                if (pending?.colorHex || pending?.colorName){
                  colorEl.innerHTML = `
                    <div class="rf-qb__color-info">
                      <div class="rf-qb__color-swatch" style="background-color:${pending.colorHex || '#ccc'}"></div>
                      <span class="rf-qb__color-name">${pending.colorName || 'Couleur'}</span>
                    </div>`;
                  colorEl.style.display = 'block';
                } else {
                  // Pas de couleur par défaut si pas de données
                  colorEl.style.display = 'none';
                }
                
                // 3) tailles depuis le modal natif (puisque pas dans les swatches)
                row.innerHTML = '';
                cta.disabled = true;
                cta.classList.remove('rf-qb__cta--ready');
                cta.textContent = 'Choisir une taille';
                console.log('RF QB: Attente des tailles depuis le modal natif');
                
                // Puis attendre le picker natif, mais en mode léger + sync automatique
                (async ()=>{
                  // si on a déjà construit des pills via pending, on veut juste sync au natif
                  const hadPills = !!row.querySelector('.rf-qb__size');
                  const {radios, btns, sels} = await waitForSizes(modal, 1200);
                  const items = radios.length ? radios : (btns.length ? btns : []);
                  if (!items.length && !hadPills) {
                    // rien à synchroniser
                    return;
                  }
                  
                  // Créer les pills depuis le natif (puisque pas de pending)
                  if (items.length){
                    console.log('RF QB: Création des pills depuis le modal natif:', items.length, 'items');
                    row.innerHTML = '';
                    items.forEach((src, i)=>{
                      const pill = document.createElement('button');
                      pill.type = 'button';
                      pill.className = 'rf-qb__size';
                      const id = src.id;
                      const lbl = id ? modal.querySelector(`label[for="${CSS.escape(id)}"]`) : null;
                      pill.textContent = (src.getAttribute?.('data-value') || lbl?.innerText || src.value || src.textContent || `Taille ${i+1}`).trim();
                      pill.disabled = !!src.disabled;
                      pill.setAttribute('aria-pressed','false');
                      pill.addEventListener('click', ()=>{
                        if (pill.disabled) return;
                        row.querySelectorAll('.rf-qb__size').forEach(p=>p.setAttribute('aria-pressed','false'));
                        // refléter la sélection dans le natif
                        if (src.tagName === 'BUTTON'){
                          items.forEach(b=>b.classList?.remove('is-selected'));
                          src.classList?.add('is-selected');
                          src.click();
                        } else {
                          items.forEach(r=>r.checked=false);
                          src.checked = true;
                          src.dispatchEvent(new Event('change', {bubbles:true}));
                        }
                        pill.setAttribute('aria-pressed','true');
                        cta.disabled = false;
                        cta.classList.add('rf-qb__cta--ready');
                        cta.textContent = 'Ajouter au panier';
                        
                        // Mettre à jour le variant ID dans le formulaire natif
                        const form = modal.querySelector('product-form form, form.shopify-product-form, form[id*="product-form"], form[action*="/cart/add"]');
                        if (form) {
                          let idInput = form.querySelector('input[name="id"]');
                          if (!idInput) {
                            idInput = document.createElement('input');
                            idInput.type = 'hidden';
                            idInput.name = 'id';
                            form.appendChild(idInput);
                          }
                          
                          // Récupérer le variant ID depuis l'élément natif sélectionné
                          const variantId = src.value || src.getAttribute('data-variant-id') || src.id;
                          if (variantId) {
                            idInput.value = variantId;
                            console.log('[RF] Variant ID mis à jour dans le formulaire:', variantId, 'pour la taille:', pill.textContent);
                          } else {
                            // Si pas de variant ID dans l'élément natif, essayer de le calculer
                            // en combinant le produit de la swatch avec la taille sélectionnée
                            const swatchVariantId = window.__rfLastClickedSwatch?.getAttribute('data-variant-id');
                            if (swatchVariantId) {
                              console.log('[RF] Pas de variant ID dans l\'élément natif, utilisation du variant ID de la swatch:', swatchVariantId);
                              idInput.value = swatchVariantId;
                            }
                          }
                        }
                      }, {signal: ac.signal});
                      row.appendChild(pill);
                    });
                  } else {
                    // Fallback: créer des tailles par défaut si rien n'est trouvé
                    console.log('RF QB: Aucune taille trouvée, création de tailles par défaut');
                    const defaultSizes = ['XS/34', 'S/36', 'M/38', 'L/40'];
                    row.innerHTML = '';
                    defaultSizes.forEach((size, i) => {
                      const pill = document.createElement('button');
                      pill.type = 'button';
                      pill.className = 'rf-qb__size';
                      pill.textContent = size;
                      pill.disabled = false;
                      pill.setAttribute('aria-pressed','false');
                      pill.addEventListener('click', ()=>{
                        if (pill.disabled) return;
                        row.querySelectorAll('.rf-qb__size').forEach(p=>p.setAttribute('aria-pressed','false'));
                        pill.setAttribute('aria-pressed','true');
                        cta.disabled = false;
                        cta.classList.add('rf-qb__cta--ready');
                        cta.textContent = 'Ajouter au panier';
                        
                        // Pour les tailles par défaut, on ne peut pas récupérer le variant ID
                        // car on n'a pas d'élément natif correspondant
                        console.log('[RF] Taille par défaut sélectionnée:', pill.textContent, '- variant ID non disponible');
                      }, {signal: ac.signal});
                      row.appendChild(pill);
                    });
                  }
                  
                  // garde la synchro si le thème change l'état tout seul
                  items.forEach((it, idx)=>{
                    const evt = it.tagName === 'BUTTON' ? 'click' : 'change';
                    it.addEventListener(evt, ()=>{
                      const pills = row.querySelectorAll('.rf-qb__size');
                      pills[idx]?.setAttribute('aria-pressed', (it.tagName === 'BUTTON') ? (it.classList.contains('is-selected') || it.getAttribute('aria-pressed')==='true' ? 'true':'false') : (it.checked ? 'true':'false') );
                      cta.disabled = ![...pills].some(p=>p.getAttribute('aria-pressed')==='true');
                      cta.classList.toggle('rf-qb__cta--ready', !cta.disabled);
                      cta.textContent = cta.disabled ? 'Choisir une taille' : 'Ajouter au panier';
                    }, {signal: ac.signal});
                  });
                  
                  // ---------- RF: Gestion du stock systématique ----------
                  (async function updateStockStatus() {
                    console.log('[RF] DEBUG - Début de la gestion du stock');
                    
                    // Stocker les variants globalement pour le CTA
                    window.__rfCurrentProductVariants = null;
                    
                    // Fonction locale pour mettre à jour la disponibilité des tailles
                    function updateSizeAvailability(variants) {
                      const sizePills = modal.querySelectorAll('.rf-qb__size');
                      console.log('[RF] DEBUG - Mise à jour de la disponibilité pour', sizePills.length, 'tailles');
                      
                      sizePills.forEach(pill => {
                        const sizeLabel = pill.textContent.trim();
                        console.log('[RF] DEBUG - Vérification de la taille:', sizeLabel);
                        
                        // Chercher le variant correspondant à cette taille
                        const variant = variants.find(v => {
                          const variantTitle = v.title || v.option1 || '';
                          return variantTitle.includes(sizeLabel) || sizeLabel.includes(variantTitle);
                        });
                        
                        if (variant) {
                          const isAvailable = variant.available;
                          console.log('[RF] DEBUG - Variant trouvé pour', sizeLabel, ':', variant.title, '- Disponible:', isAvailable);
                          
                          if (!isAvailable) {
                            // Marquer comme indisponible
                            pill.disabled = true;
                            pill.classList.add('rf-qb__size--unavailable');
                            pill.setAttribute('aria-label', `${sizeLabel} - Rupture de stock`);
                            console.log('[RF] DEBUG - Taille', sizeLabel, 'marquée comme indisponible');
                          } else {
                            // Marquer comme disponible
                            pill.disabled = false;
                            pill.classList.remove('rf-qb__size--unavailable');
                            pill.removeAttribute('aria-label');
                            console.log('[RF] DEBUG - Taille', sizeLabel, 'marquée comme disponible');
                          }
                        } else {
                          console.log('[RF] DEBUG - Aucun variant trouvé pour la taille:', sizeLabel);
                        }
                      });
                    }
                    
                    // 1. Essayer de récupérer le handle du produit
                    let productHandle = null;
                    
                    // Debug: afficher toutes les informations disponibles
                    console.log('[RF] DEBUG - window.__rfLastClickedCard:', window.__rfLastClickedCard);
                    console.log('[RF] DEBUG - window.__rfLastClickedSwatch:', window.__rfLastClickedSwatch);
                    
                    // Debug: afficher tous les attributs de la swatch
                    if (window.__rfLastClickedSwatch) {
                      console.log('[RF] DEBUG - Tous les attributs de la swatch:');
                      for (const attr of window.__rfLastClickedSwatch.attributes) {
                        console.log(`  ${attr.name}: ${attr.value}`);
                      }
                    }
                    
                    // Priorité 1: Depuis la swatch cliquée (plus fiable pour les variants)
                    const swatchUrl = window.__rfLastClickedSwatch?.getAttribute('data-target-url');
                    console.log('[RF] DEBUG - Swatch URL complète:', swatchUrl);
                    console.log('[RF] DEBUG - Swatch data-product-title:', window.__rfLastClickedSwatch?.getAttribute('data-product-title'));
                    console.log('[RF] DEBUG - Swatch data-color-name:', window.__rfLastClickedSwatch?.getAttribute('data-color-name'));
                    
                    if (swatchUrl && swatchUrl.includes('/products/')) {
                      productHandle = swatchUrl.split('/products/')[1]?.split('?')[0];
                      console.log('[RF] DEBUG - Handle depuis swatch:', productHandle);
                    } else {
                      console.log('[RF] DEBUG - Pas d\'URL de swatch valide');
                    }
                    
                    // Priorité 2: Depuis la card qui a déclenché l'ouverture (si pas de swatch)
                    if (!productHandle) {
                      const card = window.__rfLastClickedCard;
                      if (card) {
                        console.log('[RF] DEBUG - Card trouvée:', card);
                        console.log('[RF] DEBUG - Card handle:', card.getAttribute('data-product-handle'));
                        console.log('[RF] DEBUG - Card data-handle:', card.getAttribute('data-handle'));
                        
                        productHandle = card.getAttribute('data-product-handle') || 
                                       card.getAttribute('data-handle') ||
                                       card.querySelector('[data-product-handle]')?.getAttribute('data-product-handle') ||
                                       card.querySelector('[data-handle]')?.getAttribute('data-handle');
                        console.log('[RF] DEBUG - Handle depuis card:', productHandle);
                      } else {
                        console.log('[RF] DEBUG - Aucune card trouvée dans window.__rfLastClickedCard');
                      }
                    }
                    
                    // Depuis le modal si toujours pas
                    if (!productHandle) {
                      productHandle = modal.getAttribute('data-product-handle') || 
                                     modal.getAttribute('data-handle') ||
                                     modal.querySelector('[data-product-handle]')?.getAttribute('data-product-handle') ||
                                     modal.querySelector('[data-handle]')?.getAttribute('data-handle');
                      console.log('[RF] DEBUG - Handle depuis modal:', productHandle);
                    }
                    
                    // Fallback: essayer de récupérer depuis l'URL du modal ou les éléments internes
                    if (!productHandle) {
                      // Chercher dans tous les éléments du modal
                      const allElements = modal.querySelectorAll('*');
                      for (const el of allElements) {
                        const handle = el.getAttribute('data-product-handle') || 
                                     el.getAttribute('data-handle') ||
                                     el.getAttribute('href')?.split('/products/')?.[1]?.split('?')?.[0];
                        if (handle) {
                          productHandle = handle;
                          console.log('[RF] DEBUG - Handle trouvé dans un élément du modal:', productHandle);
                          break;
                        }
                      }
                    }
                    
                    // 2. Récupérer les données du produit
                    if (productHandle) {
                      try {
                        console.log('[RF] DEBUG - Récupération des données du produit:', productHandle);
                        console.log('[RF] DEBUG - URL de la swatch:', window.__rfLastClickedSwatch?.getAttribute('data-target-url'));
                        console.log('[RF] DEBUG - Variant ID de la swatch:', window.__rfLastClickedSwatch?.getAttribute('data-variant-id'));
                        
                        const productResponse = await fetch(`/products/${productHandle}.js`);
                                                  if (productResponse.ok) {
                            const productData = await productResponse.json();
                            console.log('[RF] DEBUG - Données du produit récupérées:', productData.title);
                            
                            // Vérifier si le variant de la swatch est dans les données
                            const swatchVariantId = window.__rfLastClickedSwatch?.getAttribute('data-variant-id');
                            const swatchVariantInData = productData.variants.find(v => v.id == swatchVariantId);
                            console.log('[RF] DEBUG - Variant de la swatch dans les données:', swatchVariantInData ? 'OUI' : 'NON');
                            if (swatchVariantInData) {
                              console.log('[RF] DEBUG - Variant trouvé:', swatchVariantInData.title);
                            }
                          
                          // 3. Stocker les variants globalement et mettre à jour les tailles
                          window.__rfCurrentProductVariants = productData.variants;
                          updateSizeAvailability(productData.variants);
                          
                          // 4. Mettre à jour le titre si nécessaire
                          console.log('[RF] DEBUG - Recherche de l\'élément titre dans le modal');
                          const titleSelectors = [
                            '.rf-qb__title', 
                            'h1', 
                            '.product-title', 
                            '[data-product-title]',
                            '.modal__title',
                            '.quick-buy-modal__title',
                            '[class*="title"]',
                            'h2',
                            'h3'
                          ];
                          
                          let titleElement = null;
                          for (const selector of titleSelectors) {
                            titleElement = modal.querySelector(selector);
                            if (titleElement) {
                              console.log('[RF] DEBUG - Élément titre trouvé avec le sélecteur:', selector);
                              break;
                            }
                          }
                          
                          if (titleElement) {
                            const currentTitle = titleElement.textContent.trim();
                            console.log('[RF] DEBUG - Titre actuel:', currentTitle);
                            
                            if (!currentTitle || currentTitle === 'Guide des tailles' || currentTitle === '') {
                              titleElement.textContent = productData.title;
                              console.log('[RF] DEBUG - Titre mis à jour:', productData.title);
                            } else {
                              console.log('[RF] DEBUG - Titre déjà correct, pas de mise à jour nécessaire');
                            }
                          } else {
                            console.log('[RF] DEBUG - Aucun élément titre trouvé avec les sélecteurs, recherche par texte');
                            
                            // Fallback: chercher par le texte "Guide des tailles"
                            const allElements = modal.querySelectorAll('*');
                            for (const el of allElements) {
                              if (el.textContent && el.textContent.includes('Guide des tailles')) {
                                el.textContent = productData.title;
                                console.log('[RF] DEBUG - Titre mis à jour via recherche par texte:', productData.title);
                                break;
                              }
                            }
                          }
                        } else {
                          console.log('[RF] DEBUG - Erreur lors de la récupération du produit:', productResponse.status);
                        }
                      } catch (error) {
                        console.log('[RF] DEBUG - Erreur lors de la récupération du produit:', error);
                      }
                    } else {
                      console.log('[RF] DEBUG - Aucun handle de produit trouvé');
                    }
                  })();
                })();

    modal.__rfEnhanced = true;
    console.log('Modal enhanced successfully');

                // CLEAN à la fermeture
            const cleanup = () => {
              if (modal.__rfAbort) { 
                modal.__rfAbort.abort(); 
                modal.__rfAbort = null; 
              }
              modal.querySelector('.rf-qb')?.remove();
              modal.classList.remove('rf-qb-active');
              modal.__rfEnhanced = false;

              console.log('Modal cleanup completed');
            };

    attachCloseWatch(modal, cleanup);
  }

  function enhanceAll(){
    if (!isMobile()) return;
    
    const openModals = getOpenModals();
    console.log('Found open modals:', openModals.length);
    
    openModals.forEach(m => {
      // Toujours ré-enhancer si le modal est ouvert et pas déjà traité
      if (!m.__rfEnhanced) {
        console.log('Enhancing new modal');
        setTimeout(()=>enhanceModal(m), 100);
      } else {
        console.log('Modal already enhanced, skipping');
      }
    });
  }

  // Observer plus intelligent
  const obs = new MutationObserver((mutations) => {
    let shouldCheck = false;
    
    mutations.forEach(mutation => {
      // Vérifier si un modal a changé d'état
      if (mutation.type === 'attributes' && 
          (mutation.attributeName === 'open' || mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
        const target = mutation.target;
        if (target.classList && target.classList.contains('quick-buy-modal')) {
          shouldCheck = true;
        }
      }
      
      // Vérifier si des modals ont été ajoutés/supprimés
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.classList && node.classList.contains('quick-buy-modal')) {
            shouldCheck = true;
          }
        });
        mutation.removedNodes.forEach(node => {
          if (node.nodeType === 1 && node.classList && node.classList.contains('quick-buy-modal')) {
            shouldCheck = true;
          }
        });
      }
    });
    
    if (shouldCheck) {
      console.log('Modal state changed, checking...');
      setTimeout(enhanceAll, 100);
    }
  });
  
  obs.observe(document.documentElement, {childList:true, subtree:true, attributes:true});

            // Écouter les clics sur les boutons quick-add et les swatches
          document.addEventListener('click', (e) => {
            console.log('RF QB: Clic détecté sur:', e.target);
            console.log('RF QB: Classes de l\'élément cliqué:', e.target.className);
            console.log('RF QB: TagName de l\'élément cliqué:', e.target.tagName);
            
            // --- FAST PATH: préparer le modal dès le clic sur le quick-add
            const quickAddBtn = e.target.closest('.product-card__quick-add-button,[aria-controls*="quick-buy"]');
            if (quickAddBtn) {
              console.log('RF QB: Bouton quick-add cliqué');
              
              const modalId = quickAddBtn.getAttribute('aria-controls');
              const modal = modalId ? document.getElementById(modalId) : null;
              if (!modal) return;
              
              // Carte & swatch active
              const card = quickAddBtn.closest('.product-card, [data-card-id]') || document;
              const sw = card.querySelector('.card-color-swatch__link.active, .card-color-swatch__link[aria-pressed="true"]') || 
                        (window.__rfLastClickedSwatch && card.contains(window.__rfLastClickedSwatch) ? window.__rfLastClickedSwatch : null) ||
                        card.querySelector('.card-color-swatch__link');
              
              console.log('RF QB: Card found:', card);
              console.log('RF QB: Swatch found:', sw);
              console.log('RF QB: Swatch data-sizes:', sw?.getAttribute('data-sizes'));
              console.log('RF QB: Swatch data-product-title:', sw?.getAttribute('data-product-title'));
              
              // Contexte minimal à réutiliser dans enhanceModal
              const pending = {
                title: sw?.getAttribute('data-product-title') || card.querySelector('.product-card__title, h3, h4')?.textContent?.trim() || '',
                colorHex: sw?.getAttribute('data-color-hex') || '',
                colorName: sw?.getAttribute('data-color-name') || '',
                sizes: safeJson(sw?.getAttribute('data-sizes')),
                sizeIds: safeJson(sw?.getAttribute('data-size-ids')),
                sizeAvail: safeJson(sw?.getAttribute('data-size-available')),
                mainImg: sw?.getAttribute('data-image-main') || '',
                variantId: sw?.getAttribute('data-variant-id') || '',
              };
              
              console.log('RF QB: Pending data captured:', pending);
              
              // stocke proprement (pas d'attributs lourds)
              modal.__rfPending = pending;
              
              // si on peut, ajuster le handle avant ouverture pour cibler la bonne variante
              const handle = sw?.getAttribute('data-product-handle');
              if (handle && pending.variantId) {
                modal.setAttribute('handle', `${handle}?variant=${pending.variantId}`);
                console.log('RF QB: Mise à jour du modal avec handle:', `${handle}?variant=${pending.variantId}`);
              }
            }
            
            function safeJson(s){
              try { 
                console.log('RF QB: safeJson input:', s);
                const result = s ? JSON.parse(s) : [];
                console.log('RF QB: safeJson result:', result);
                return result;
              } catch(e){ 
                console.log('RF QB: safeJson error:', e, 'for input:', s);
                return []; 
              }
            }
            
            // Détecter les clics sur les swatches
            const swatch = e.target.closest('.card-color-swatch__link');
            console.log('RF QB: Swatch trouvée:', !!swatch, 'Dans modal:', !!swatch?.closest('.quick-buy-modal'));
            
            if (swatch) {
              console.log('RF QB: Swatch trouvée - classes:', swatch.className);
              console.log('RF QB: Swatch trouvée - data-product-title:', swatch.getAttribute('data-product-title'));
              console.log('RF QB: Swatch trouvée - data-color-hex:', swatch.getAttribute('data-color-hex'));
              
              // Mémoriser cette swatch comme la dernière cliquée
              window.__rfLastClickedSwatch = swatch;
              console.log('RF QB: Swatch mémorisée comme dernière cliquée');
            }
            
            if (swatch && !swatch.closest('.quick-buy-modal')) {
              console.log('RF QB: Swatch cliquée, données:', {
                title: swatch.getAttribute('data-product-title'),
                colorHex: swatch.getAttribute('data-color-hex'),
                colorName: swatch.getAttribute('data-color-name'),
                targetUrl: swatch.getAttribute('data-target-url'),
                variantId: swatch.getAttribute('data-variant-id')
              });
              
              // Un swatch a été cliqué dans une carte produit
              setTimeout(() => {
                const openModals = getOpenModals();
                console.log('RF QB: Modals ouverts trouvés:', openModals.length);
                openModals.forEach(modal => {
                  if (modal.__rfEnhanced) {
                    // Mettre à jour TOUS les modals ouverts, peu importe la carte
                    console.log('RF QB: Mise à jour de tous les modals ouverts...');
                      
                    // Recharger la variante dans le modal ouvert
                    const titleEl = modal.querySelector('.rf-qb__title');
                    const desktopTitleEl = modal.querySelector('.product-title.h6');
                    const infoEl = modal.querySelector('.rf-qb__info');
                    
                    console.log('RF QB: Éléments trouvés - titleEl:', !!titleEl, 'desktopTitleEl:', !!desktopTitleEl, 'infoEl:', !!infoEl);
                    
                    // Mettre à jour le titre ET la couleur depuis la swatch cliquée
                    if (swatch) {
                      const productTitle = swatch.getAttribute('data-product-title');
                      const colorHex = swatch.getAttribute('data-color-hex');
                      const colorName = swatch.getAttribute('data-color-name');
                      
                      console.log('RF QB: Données de la swatch cliquée:', { productTitle, colorHex, colorName });
                      
                      // Mettre à jour le titre (mobile ET desktop)
                      if (productTitle) {
                        // Titre mobile
                        if (titleEl) {
                          titleEl.textContent = productTitle;
                          console.log('RF QB: Titre mobile mis à jour vers:', productTitle);
                        }
                        // Titre desktop
                        if (desktopTitleEl) {
                          desktopTitleEl.textContent = productTitle;
                          console.log('RF QB: Titre desktop mis à jour vers:', productTitle);
                        }
                      } else {
                        console.log('RF QB: Pas de data-product-title trouvé sur la swatch');
                      }
                      
                      // Mettre à jour la couleur
                      if (colorHex && colorName) {
                        // Chercher l'élément couleur existant ou le créer
                        let colorEl = infoEl.querySelector('.rf-qb__color');
                        if (!colorEl) {
                          colorEl = document.createElement('div');
                          colorEl.className = 'rf-qb__color';
                          // Insérer après le prix et avant les tailles
                          const priceEl = infoEl.querySelector('.rf-qb__price');
                          if (priceEl && priceEl.nextElementSibling) {
                            infoEl.insertBefore(colorEl, priceEl.nextElementSibling);
                          } else {
                            infoEl.appendChild(colorEl);
                          }
                        }
                        
                        colorEl.innerHTML = `
                          <div class="rf-qb__color-info">
                            <div class="rf-qb__color-swatch" style="background-color: ${colorHex}"></div>
                            <span class="rf-qb__color-name">${colorName}</span>
                          </div>
                        `;
                        colorEl.style.display = 'block';
                        console.log('RF QB: Couleur du modal mise à jour vers:', colorName, colorHex);
                      }
                      
                      // Mettre à jour le variant ID dans le formulaire
                      const variantId = swatch.getAttribute('data-variant-id');
                      console.log('[RF] DEBUG - Variant ID récupéré depuis swatch:', variantId);
                      console.log('[RF] DEBUG - Tous les attributs de la swatch:', {
                        'data-variant-id': swatch.getAttribute('data-variant-id'),
                        'data-product-title': swatch.getAttribute('data-product-title'),
                        'data-color-hex': swatch.getAttribute('data-color-hex'),
                        'data-color-name': swatch.getAttribute('data-color-name'),
                        'data-target-url': swatch.getAttribute('data-target-url')
                      });
                      if (variantId) {
                        const form = modal.querySelector('product-form form, form.shopify-product-form, form[id*="product-form"], form[action*="/cart/add"]');
                        if (form) {
                          let idInput = form.querySelector('input[name="id"]');
                          if (!idInput) {
                            idInput = document.createElement('input');
                            idInput.type = 'hidden';
                            idInput.name = 'id';
                            form.appendChild(idInput);
                          }
                          idInput.value = variantId;
                          console.log('[RF] Variant ID mis à jour depuis la swatch cliquée:', variantId);
                        }
                      }
                    } else {
                      console.log('RF QB: Élément titre non trouvé dans le modal');
                    }
                    
                    // Créer/mettre à jour l'élément couleur
                    if (infoEl && swatch) {
                      const colorHex = swatch.getAttribute('data-color-hex');
                      const colorName = swatch.getAttribute('data-color-name');
                      
                      if (colorHex && colorName) {
                        // Chercher l'élément couleur existant ou le créer
                        let colorEl = infoEl.querySelector('.rf-qb__color');
                        if (!colorEl) {
                          colorEl = document.createElement('div');
                          colorEl.className = 'rf-qb__color';
                          // Insérer après le prix et avant les tailles
                          const priceEl = infoEl.querySelector('.rf-qb__price');
                          if (priceEl && priceEl.nextElementSibling) {
                            infoEl.insertBefore(colorEl, priceEl.nextElementSibling);
                          } else {
                            infoEl.appendChild(colorEl);
                          }
                        }
                        
                        colorEl.innerHTML = `
                          <div class="rf-qb__color-info">
                            <div class="rf-qb__color-swatch" style="background-color: ${colorHex}"></div>
                            <span class="rf-qb__color-name">${colorName}</span>
                          </div>
                        `;
                        console.log('RF QB: Couleur du modal mise à jour vers:', colorName, colorHex);
                      }
                    }
                    
                    // Mettre à jour la couleur au chargement initial du modal
                    if (infoEl && !swatch) {
                      console.log('RF QB: Tentative de mise à jour de la couleur initiale...');
                      
                      // Méthode 1: Chercher la swatch active sur la page
                      let activeSwatch = document.querySelector('.card-color-swatch__link.active');
                      console.log('RF QB: Swatch active trouvée:', !!activeSwatch);
                      
                      // Méthode 2: Si pas de swatch active, chercher par titre du produit
                      if (!activeSwatch) {
                        const titleEl = modal.querySelector('.rf-qb__title, .product-title.h6');
                        const modalTitle = titleEl ? titleEl.textContent.trim() : '';
                        
                        console.log('RF QB: Titre du modal:', modalTitle);
                        
                        if (modalTitle) {
                          // Chercher la swatch qui correspond à ce titre
                          const allSwatches = document.querySelectorAll('.card-color-swatch__link');
                          for (const s of allSwatches) {
                            const swatchTitle = s.getAttribute('data-product-title');
                            if (swatchTitle && swatchTitle.trim() === modalTitle) {
                              activeSwatch = s;
                              console.log('RF QB: Swatch trouvée par titre:', modalTitle);
                              break;
                            }
                          }
                        }
                      }
                      
                      if (activeSwatch) {
                        const colorHex = activeSwatch.getAttribute('data-color-hex');
                        const colorName = activeSwatch.getAttribute('data-color-name');
                        
                        console.log('RF QB: Données de la swatch trouvée:', { colorHex, colorName });
                        
                        if (colorHex && colorName) {
                          // Chercher l'élément couleur existant ou le créer
                          let colorEl = infoEl.querySelector('.rf-qb__color');
                          if (!colorEl) {
                            colorEl = document.createElement('div');
                            colorEl.className = 'rf-qb__color';
                            // Insérer après le prix et avant les tailles
                            const priceEl = infoEl.querySelector('.rf-qb__price');
                            if (priceEl && priceEl.nextElementSibling) {
                              infoEl.insertBefore(colorEl, priceEl.nextElementSibling);
                            } else {
                              infoEl.appendChild(colorEl);
                            }
                          }
                          
                          colorEl.innerHTML = `
                            <div class="rf-qb__color-info">
                              <div class="rf-qb__color-swatch" style="background-color: ${colorHex}"></div>
                              <span class="rf-qb__color-name">${colorName}</span>
                            </div>
                          `;
                          console.log('RF QB: Couleur initiale du modal mise à jour vers:', colorName, colorHex);
                        } else {
                          console.log('RF QB: Pas de données de couleur trouvées sur la swatch');
                        }
                      } else {
                        console.log('RF QB: Aucune swatch trouvée, toutes les swatches:', document.querySelectorAll('.card-color-swatch__link').length);
                        // Debug: afficher toutes les swatches
                        document.querySelectorAll('.card-color-swatch__link').forEach((s, i) => {
                          console.log(`RF QB: Swatch ${i}:`, {
                            classes: s.className,
                            colorHex: s.getAttribute('data-color-hex'),
                            colorName: s.getAttribute('data-color-name'),
                            variantId: s.getAttribute('data-variant-id')
                          });
                        });
                      }
                    }
                  }
                });
              }, 100);
            }
          });

          (document.readyState === 'loading')
            ? document.addEventListener('DOMContentLoaded', enhanceAll)
            : enhanceAll();
})();

// Cache buster: Wed Aug 20 17:56:55 CEST 2025
// FORCE REFRESH: 1755707539
// FORCE REFRESH 2: 1755707784
// FORCE REFRESH 3: 1755708041
// ULTIMATE REFRESH: 1755708194
// PATCH COMPLET: 1755708467
// HEADER GLOBAL FIX: 1755708595
// SIMPLE FIX: 1755708769
// SHADOW DOM FIX: 1755708882
/* WORKING VERSION APPLIED: 1755781782 */
/* FILES RENAMED FOR CLARITY: 1755781873 */
/* UPDATE COLOR AND TITLE FROM ACTIVE SWATCH: 1755787944 */
/* FIX COLOR AND TITLE UPDATE: 1755788031 */
/* RELOAD MODAL CONTENT FROM PRODUCT URL: 1755788200 */
/* ADD DEBUG LOGS FOR SWATCH CLICKS: 1755788326 */
/* FIX SWATCH SELECTOR: 1755788385 */
/* ADD INITIAL COLOR UPDATE: 1755788552 */
/* ADD DEBUG LOGS FOR INITIAL COLOR: 1755788665 */
/* ADD VARIANT ID MATCHING FOR COLOR: 1755788771 */
/* USE PRODUCT TITLE FOR COLOR MATCHING: 1755788846 */
/* MOVE COLOR UPDATE TO ENHANCEMODAL: 1755788933 */
/* UPDATE TITLE AND COLOR ON SWATCH CLICK: 1755789016 */
/* DEBUG SWATCH DETECTION: 1755789090 */
/* ADD SWATCH CLICK DEBUG: 1755789106 */
/* IMPROVE ACTIVE SWATCH DETECTION: 1755789225 */
/* INTERCEPT QUICK-ADD BUTTON CLICKS: 1755789337 */
/* FIX DOUBLE CLICK ISSUE: 1755790179 */
/* MEMORIZE LAST CLICKED SWATCH: 1755790275 */
/* FAST PATH OPTIMIZATION: 1755790523 */
/* ADD SIZES DATA TO SWATCHES: 1755790620 */
/* DEBUG SWATCH DATA CAPTURE: 1755790676 */
/* FIX PRICE AND SIZES DISPLAY: 1755790781 */
/* DEBUG JSON PARSING: 1755790848 */
/* FIX JSON ESCAPING IN LIQUID: 1755790910 */
/* FALLBACK TO NATIVE SIZES: 1755790991 */
/* IMPROVE SIZE DETECTION AND FALLBACK: 1755791100 */
/* QUEUE + NEUTRALIZATION: 1755795644 */
/* FIX VARIANT ID FROM SWATCH: 1755795802 */
/* DEBUG VARIANT ID: 1755795894 */
/* PRIORITY SWATCH VARIANT ID: 1755796074 */
/* FIND CORRECT SIZE VARIANT: 1755796258 */
/* DEBUG NATIVE ELEMENTS + URL VARIANT: 1755796398 */
/* FETCH PRODUCT DATA FOR CORRECT VARIANT: 1755796549 */
/* ALWAYS FETCH PRODUCT DATA: 1755796641 */
/* STOCK MANAGEMENT COMPLETE: 1755796880 */
/* HANDLE PRODUCT WITHOUT SWATCH: 1755797030 */
/* SYSTEMATIC STOCK MANAGEMENT: 1755797162 */
/* FIX MODAL SCOPE + CORRECT HANDLE: 1755797804 */
/* FIX MODAL SCOPE + LOCAL FUNCTION: 1755798567 */
/* DEBUG HANDLE DETECTION: 1755803016 */
/* FIX SYNTAX ERRORS: 1755803246 */
/* DISPLAY TITLE AND PRICE WITHOUT SWATCH: 1755803246 */
/* CAPTURE CLICKED CARD: 1755803766 */
/* IMPROVE CARD DETECTION + FALLBACK: 1755803897 */
/* IMPROVE TITLE DETECTION: 1755804011 */
/* FIX VARIANT SELECTION BY COLOR AND SIZE: 1755804172 */
/* IMPROVE SIZE MATCHING LOGIC: 1755804278 */
/* DEBUG ALL VARIANTS + NATIVE FALLBACK: 1755804396 */
/* DEBUG SWATCH VS PRODUCT DATA: 1755804485 */
/* PRIORITY SWATCH OVER CARD: 1755804626 */
/* DEBUG SWATCH ATTRIBUTES: 1755804783 */
/* FIX COLOR MATCHING LOGIC: 1755804983 */
/* EXTRACT COLOR FROM TITLE: 1755805137 */
/* DEBUG COLOR EXTRACTION: 1755805209 */
/* SIMPLIFIED SIZE MATCHING: 1755805364 */
/* FIX OOS DISPLAY: 1755805491 */
/* FIX PRICE DISPLAY: 1755805902 */


document.addEventListener('variant:add', function (event) {
  const modal = event.target.closest?.('quick-buy-modal');
  if (!modal || typeof window.corner?.do !== 'function') return;
  Promise.resolve(modal.hide()).then(function () {
    window.corner.do('refreshCart');
    window.corner.do('openCart');
  });
});


document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-rf-cart-product]');
  const card = button?.closest('product-card');
  const picker = card?.querySelector('.rf-card-size-picker');
  if (picker) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const opening = picker.hidden;
    document.querySelectorAll('.rf-card-size-picker').forEach(function (other) {
      other.hidden = true;
      other.closest('product-card')?.querySelector('[data-rf-cart-product]')?.setAttribute('aria-expanded', 'false');
    });
    picker.hidden = !opening;
    button.setAttribute('aria-expanded', String(opening));
    if (opening) picker.querySelector('button:not(:disabled)')?.focus();
  } else if (!event.target.closest('.rf-card-size-picker')) {
    document.querySelectorAll('.rf-card-size-picker').forEach(function (other) {
      other.hidden = true;
      other.closest('product-card')?.querySelector('[data-rf-cart-product]')?.setAttribute('aria-expanded', 'false');
    });
  }
}, true);
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.rf-card-size-picker:not([hidden])').forEach(function (picker) {
    picker.hidden = true;
    const button = picker.closest('product-card')?.querySelector('[data-rf-cart-product]');
    button?.setAttribute('aria-expanded', 'false');
    button?.focus();
  });
});
document.addEventListener('variant:add', function (event) {
  const picker = event.target.closest?.('.rf-card-size-picker');
  if (!picker) return;
  picker.hidden = true;
  picker.closest('product-card')?.querySelector('[data-rf-cart-product]')?.setAttribute('aria-expanded', 'false');
  if (typeof window.corner?.do === 'function') {
    window.corner.do('refreshCart');
    window.corner.do('openCart');
  }
});
